<template>
   <banner :bgImage="bannerInfo.file || bgImage"  :title="bannerInfo.title" :subTitle="bannerInfo.subTitle || bannerInfo.desc"></banner>
    <div class="main-bg" v-if="status==0">
        <div class="wrap">
            <Ani class="about-video">
                <div class="about-video-img" ref="videoBoxRef">
                    <img ref="posterRef" src="@/assets/images/about/about-img.webp" alt="video">
                    <video ref="videoRef" :src="intro.videoUrl" loop playsinline webkit-playsinline x5-playsinline></video>
                    <div class="about-video-btn" @click="videoPlay"></div>
                </div>
            </Ani>
            <div class="about-text">
                <Ani><h2 class="about-title font36 color-m">{{intro.title}}</h2></Ani>
                <Ani class="about-con font16 color-f">
                    <ul class="about-list list-style flex flex-wrap justify-between">
                        <li v-for="item in intro && intro.dataList">
                            <div class="about-num font18 color-f"><strong class="font40"><CountUp :endVal="item.count" :duration="2" /></strong>{{ item.unit }}</div>
                            <div class="about-info font16 color-f">
                                <p>{{item.title}}</p>
                            </div>
                        </li>
                    </ul>
                    <div v-html="intro.detail"></div>
                </Ani>
            </div>
        </div>
    </div>
    <error :status="status" v-if="status>0"></error>
</template>
<script setup lang="ts">
    import { ref, onMounted,reactive } from 'vue'
    import useServerRequest from '@/composables/useServerRequest'
    import type { configParams,configResponse,bannerConfig,IntroConfig} from '~/types';
    import { useI18n } from 'vue-i18n' // 导入 useI18n
    const { locale } = useI18n() // 获取当前 i18n 语言（如 zh-CN/en-US）
    const bgImage = ref(staticURL('/banner/about-banner.webp'))
    import { handleApiResponse } from "@/utils/utils"
    const config = useRuntimeConfig()
    const cmsurlStrategy = config?.public?.cmsStrategy

    // 获取DOM元素引用
    const posterRef = ref<any>(null)
    const videoRef = ref<any>(null)
    const videoBoxRef = ref<any>(null)

    // 播放/暂停视频
    const videoPlay = ()=>{
        if (!posterRef.value || !videoRef.value) return;

        const video = videoRef.value
        if (video.paused) {
            findBuryKey('Introduction_Page_play_button')
            // 播放视频
            video.play()
            .then(() => {
                // 隐藏图片
                posterRef.value.style.opacity = '0'
                posterRef.value.style.visibility = 'hidden'
                
                // 添加播放状态样式
                videoBoxRef.value?.classList.add('video-playing')
                // 添加自带控制器
                video.controls = true
            })
            .catch((error:any) => {
                console.error('视频播放失败:', error)
            })
        }
    }
    
    // 视频播放结束时的处理
    const handleVideoEnd = () => {
        if (posterRef.value) {
            posterRef.value.style.opacity = '1'
            posterRef.value.style.visibility = 'visible'
            videoBoxRef.value?.classList.remove('video-playing')
        }
    }
    // 视频暂停
    const videoPause = () => {
        findBuryKey('Introduction_Page_pause_button')
        const video = videoRef.value
        if (video.seeking) return
        // video.controls = false
        posterRef.value.style.opacity = '1'
        // posterRef.value.style.visibility = 'visible'
        // videoBoxRef.value?.classList.remove('video-playing')
    }
    // 组件挂载时添加事件监听
    onMounted(() => {
        if (videoRef.value) {
            videoRef.value.addEventListener('ended', handleVideoEnd)
            // 监听视频暂停
            videoRef.value.addEventListener('pause', videoPause)
        }
    })
    const infoParams = reactive<configParams>({
    pageCode: "COMPANY_INTRO"
    })
    //信息
    const status = ref<number>(0)
    //其他信息
    const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
    })
    const bannerInfo = ref<bannerConfig>({})
    const intro = ref<IntroConfig>({
    title: '',
    detail: '',
    videoUrl: '',
    dataList: []
  })
    const getInfo = async () =>{
        try {
            const { data } = await useServerRequest<configResponse>('about-index-info', `${cmsurlStrategy}/getPageConfig`, { method: 'GET', params:infoParams,language: locale.value })
            const res = data?.value
            const result = handleApiResponse(res)
            if (!result.success) {
                status.value = result.status
                return
            }
            const getInfoData = data?.value?.data?.pageValue
            seo.value=getInfoData?.seo
            intro.value=getInfoData?.intro
            bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
            console.log(data)
        } catch(error){
            status.value = 2
        }
    }
    getInfo()
    useHead({
        title: () => seo?.value?.title || '', // 保持不变（已正确）
        meta: [
          { 
            name: 'keywords', 
            content: () => seo?.value?.keywords || '' // 改为函数形式！
          },
          { 
            name: 'description', 
            content: () => seo?.value?.desc || '' // 改为函数形式！（去掉多余的模板字符串）
          }
        ]
    })
</script>
<style scoped lang="scss">
@use '@/assets/css/about.scss';
</style>